import { RewardScene, Privileges } from '@/types';
import { useReward } from '@/contexts/reward-context';
import { CloseIcon } from '../svg-icons';
import { RewardModalWrapper } from '@/components/reward-modal-wrapper';

export const LevelupPopup = () => {
	const { onClose, labels, planInfo, setRewardScene, onKafkaSet } = useReward();

	const handleClose = () => {
		onKafkaSet({
			type: 1,
			action: 29
		});

		onClose();
	}

	const goToHome = () => {
		onKafkaSet({
			type: 1,
			action: 23
		});

		setRewardScene(RewardScene.Home);
	}

	const vipLevel = planInfo?.VipLevel ?? 1;
	const vipName = planInfo?.UserName;

	return (
		<RewardModalWrapper>
			<div className="reward-modal-close">
				<div 
					className="reward-modal-close__btn"
					onClick={handleClose}
				>
					<CloseIcon />
				</div>
			</div>
			<section className="reward-upgrade">
				<div className="reward-upgrade__container">
					<div className="reward-upgrade__main">
						<div className="reward-upgrade__title">{labels?.lbl_RPLevelingUp}</div>
						<div className="reward-upgrade__badge">
							<div className="reward-badge-level" data-level={vipLevel} data-highlight="true">
								<div className="reward-badge-level__img"></div>
							</div>
							<div className="reward-upgrade__badge-label">{labels?.[vipName ?? '']}</div>
						</div>
					</div>
					<div className="reward-upgrade__driver">
						<span className="reward-upgrade__driver-text">{labels?.lbl_RPGainBenefits}</span>
					</div>
					<div className="reward-upgrade-receive">
						<div className="reward-upgrade-receive__icon">
							<i className="reward-iconcolor-percent" />
						</div>
						<div className="reward-upgrade-receive__text">{labels?.lbl_RPNLRebate}</div>
						<div className="reward-upgrade-receive__amount">
							<span className="reward-upgrade-receive__text-normal">{Privileges[vipLevel - 1].Rebate}%</span>
							<span className="reward-upgrade-receive__arrow-icon">
								<i className="reward-iconcolor-arrow-right" />
							</span>
							<span className="reward-upgrade-receive__text-strong">{Privileges[vipLevel].Rebate}%</span>
						</div>
					</div>
					<div className="reward-upgrade__footer">
						<button 
							className="reward-btn reward-btn--primary" 
							type="button"
							onClick={goToHome}
						>
							<div className="reward-btn__info">
								<span className="reward-btn__text">{labels?.lbl_RPViewReward}</span>
							</div>
						</button>
					</div>
				</div>
			</section>
		</RewardModalWrapper>
	);
};